///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { reloadTabThunk } from 'state/secondaryMarket/cpOrder/cpOrder.thunks';
import type { EpicWithThunk } from 'state/state.common';
export function loadAfterCpOrderTabContentFetchedEpic(): EpicWithThunk {
  return actions$ => {
    return actions$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace, tabType }) => workspace === 'secondaryMarketQuotes' && tabType === 'closePriceOrder'),
      mergeMap(({ tabId }) => {
        return of(reloadTabThunk(tabId));
      }),
    );
  };
}
